// FRONT
$(function() {
    Array.from(document.querySelectorAll('[google-map-component]')).forEach(map => {
        const mapFrame = document.createElement('iframe');

        const key = window.google_api_key;
        const src = map.dataset.place_id
            ? `https://www.google.com/maps/embed/v1/place?key=${key}&q=place_id:${map.dataset.place_id}`
            : map.dataset.longitude && map.dataset.latitude
                ? `https://www.google.com/maps/embed/v1/view?key=${key}&center=${map.dataset.latitude},${map.dataset.longitude}`
                : `https://www.google.com/maps/embed/v1/place?key=${key}&q=${formatAddress(map.dataset.address)}`
        
        if ('responsive' in map.dataset && map.dataset.responsive === 'true')
            mapFrame.classList.add('embed-responsive-item');
        mapFrame.setAttribute('frameborder', 0);
        mapFrame.setAttribute('src', src);
        map.parentNode.insertBefore(mapFrame, map.nextSibling);
        map.parentNode.removeChild(map);
    });
    
    const formatAddress = address => address.replace(/, /g, ',').replace(/ /g, '+');
});

// BACK
$(function() {
    Array.from(document.querySelectorAll('[google-autocomplete-wrapper]')).forEach(wrapper => {
        const autocomplete = new google.maps.places.Autocomplete(wrapper.querySelector('[google-autocomplete-search]'), {
            types: ['geocode'],
        });

        google.maps.event.addListener(autocomplete, 'place_changed', function() {
            const place = autocomplete.getPlace();
            wrapper.querySelector('[google-autocomplete-latitude]').value = place.geometry.location.lat();
            wrapper.querySelector('[google-autocomplete-longitude]').value = place.geometry.location.lng();
            wrapper.querySelector('[google-autocomplete-place_id]').value = place.place_id;
        });
    });
});